/* istanbul ignore file - will be covered by chromatic UI tests */
import { StyledMUIButton } from '@components/Button/index';
import { forwardRef, PropsWithChildren, ReactNode } from 'react';

export interface OutlineButtonProps {
  endIcon?: ReactNode;
  color?: 'primary' | 'error';
  onClick?: () => void;
}

export const OutlinedButton = forwardRef<HTMLButtonElement, PropsWithChildren<OutlineButtonProps>>(
  ({ children, endIcon, color, onClick }, ref) => (
    <StyledMUIButton ref={ref} variant="outlined" endIcon={endIcon} color={color} onClick={onClick}>
      {children}
    </StyledMUIButton>
  )
);
